import { render, staticRenderFns } from "./PracticeFileUploadDetailCommon.vue?vue&type=template&id=a2dc91b2&scoped=true&"
import script from "./PracticeFileUploadDetailCommon.vue?vue&type=script&lang=ts&"
export * from "./PracticeFileUploadDetailCommon.vue?vue&type=script&lang=ts&"
import style0 from "./PracticeFileUploadDetailCommon.vue?vue&type=style&index=0&id=a2dc91b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2dc91b2",
  null
  
)

export default component.exports